import { render, staticRenderFns } from "./PricingContextRoute.vue?vue&type=template&id=c5ff08e6&"
import script from "./PricingContextRoute.vue?vue&type=script&lang=ts&"
export * from "./PricingContextRoute.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports